<template>
    <div class="palettes-list">
        <container @drop="handleDrop" drag-handle-selector=".palette-handle">
            <draggable v-for="(palette, index) in palettes" :key="'palette-' + index">
                <div class="palettes">
                    <palette :palette="palette"
                             drag="true"
                             @swatch-selected="onSwatchSelected"
                             @duplicated="$router.push({name: 'colors'})"
                    />
                </div>
            </draggable>
        </container>
    </div>
</template>

<script>
    import Palette                  from "./Palette";
    import { Container, Draggable } from 'vue-smooth-dnd';
    import { mapState } from 'vuex';
    import Palettes     from "../../../Store/Palettes";

    export default {
        name      : "PalettesCollection",
        components: { Palette, Container, Draggable },

        computed: {
            ... mapState('Palettes', {
                palettes: state => {
                    return state.palettes
                }
            }),
        },

        methods: {
            onSwatchSelected() {
                this.$router.push({ name: 'colors' });
            },

            handleDrop({removedIndex, addedIndex}) {
                new Palettes().reorder(removedIndex, addedIndex);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .smooth-dnd-container.vertical {
        height: 100%;
    }
</style>
